(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (!customElements.get('nkv-wa-enquiry')) {
    customElements.define('nkv-wa-enquiry', class extends HTMLElement {
      connectedCallback() {
        if (this.connectForm()) return;
        // Handles markup inserted while the custom element is already registered.
        this.observer = new MutationObserver(() => {
          if (this.connectForm()) {
            this.observer.disconnect();
            this.observer = null;
          }
        });
        this.observer.observe(this, { childList: true, subtree: true });
      }

      connectForm() {
        if (this.controller) return true;
        const form = this.querySelector('[data-nkv-wa-form]');
        const mobile = this.querySelector('[data-nkv-wa-mobile]');
        const message = this.querySelector('[data-nkv-wa-message]');
        const error = this.querySelector('.nkv-wa-error');
        if (!form || !mobile || !message || !error) return false;

        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const baseMessage = this.dataset.baseMessage || '';

        mobile.addEventListener('input', () => {
          mobile.setCustomValidity('');
          mobile.removeAttribute('aria-invalid');
          error.textContent = '';
          error.hidden = true;
        }, options);

        form.addEventListener('submit', (event) => {
          if (this.dataset.recipientValid !== 'true') {
            event.preventDefault();
            return;
          }
          const typed = mobile.value.trim().replace(/\s+/g, ' ');
          const digits = typed.replace(/\D/g, '');
          if (!/^\+?[\d\s().-]+$/.test(typed) || digits.length < 8 || digits.length > 15) {
            event.preventDefault();
            const hint = 'Enter a valid mobile number: 10 digits for India, or include your country code.';
            mobile.setCustomValidity(hint);
            mobile.setAttribute('aria-invalid', 'true');
            error.textContent = hint;
            error.hidden = false;
            mobile.reportValidity();
            mobile.focus();
            return;
          }
          const customerNumber = (typed.startsWith('+') ? '+' : '') + digits;
          message.value = baseMessage.includes('[mobile]')
            ? baseMessage.split('[mobile]').join(customerNumber)
            : (baseMessage ? baseMessage + '\n\n' : '') + 'My mobile number: ' + customerNumber;
          // Native GET navigation URL-encodes the message. No popup or extra request.
        }, options);
        return true;
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        this.observer = null;
        if (this.controller) this.controller.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
